module.exports = __webpack_public_path__ + "static/media/warning.716477d0.svg";